import { asyncActionType } from "app/utils";

export const LIST = asyncActionType("@topics/LIST");
export const GET = asyncActionType("@topics/GET");
export const ADD_PROPOSAL = asyncActionType("@topics/ADD_PROPOSAL");
export const REMOVE_PROPOSAL = "@topics/REMOVE_PROPOSAL";
export const GET_PROPOSALS = "@topics/GET_PROPOSALS";
export const SET_PROPOSALS = "@topics/SET_PROPOSALS";
export const SET_DRAFTS = "@topics/SET_DRAFTS";
export const SET_LAST_VISITED = "@topics/SET_LAST_VISITED";
export const GET_PERMISSIONS = "@topics/GET_PERMISSIONS";

export const API_BASE_URL = "/api/proposal";



// WEBPACK FOOTER //
// ./src/app/topics/constants.js